import "./loadingSpinner.css";

interface LoadingSpinnerProps {
  /**
   * The accessible name for the wait. Defaulted rather than required: the twelve
   * bars below carry no text, so without a name the spinner is silent to a
   * screen reader and the surface reads as empty rather than as pending.
   */
  label?: string;
}

export const LoadingSpinner = ({ label = "Loading" }: LoadingSpinnerProps) => {
  return (
    <div className="spinner" role="status" aria-label={label}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
